import { ChipModeEnum } from '../../pages/main/shared/components/chip/chip-mode.enum';

export enum Severity {
  Info = 0,
  Low = 15,
  Medium = 40,
  High = 75,
  Critical = 90,
  Unknown = -1,
}

export namespace Severity {
  export function mapFromApiValue(severity: string): Severity {
    const severities: Record<string, Severity> = {
      ['INFO']: Severity.Info,
      ['LOW']: Severity.Low,
      ['MEDIUM']: Severity.Medium,
      ['HIGH']: Severity.High,
      ['CRITICAL']: Severity.Critical,
      ['UNKNOWN']: Severity.Unknown,
    };
    return severities[severity];
  }

  export function className(severity: Severity): string {
    const severities: Record<Severity, string> = {
      [Severity.Info]: 'severity info',
      [Severity.Low]: 'severity low',
      [Severity.Medium]: 'severity medium',
      [Severity.High]: 'severity high',
      [Severity.Critical]: 'severity critical',
      [Severity.Unknown]: 'severity unknown',
    };

    return severities[severity] || '';
  }
  export function chipMode(severity: Severity): ChipModeEnum {
    switch (severity) {
      case Severity.Info:
        return ChipModeEnum.info;
      case Severity.Low:
        return ChipModeEnum.low;
      case Severity.Medium:
        return ChipModeEnum.medium;
      case Severity.High:
        return ChipModeEnum.high;
      case Severity.Critical:
        return ChipModeEnum.critical;
      case Severity.Unknown:
        return ChipModeEnum.unknown;
    }
  }

  export function speedometerClassName(severity?: Severity): string {
    const severities: Record<Severity, string> = {
      [Severity.Info]: 'severity-name info',
      [Severity.Low]: 'severity-name low',
      [Severity.Medium]: 'severity-name medium',
      [Severity.High]: 'severity-name high',
      [Severity.Critical]: 'severity-name critical',
      [Severity.Unknown]: 'severity-name unknown',
    };

    return severity ? severities[severity] : '';
  }

  export function name(severity?: Severity): string {
    const severities: Record<Severity, string> = {
      [Severity.Info]: 'common.criticality.info',
      [Severity.Low]: 'common.criticality.low',
      [Severity.Medium]: 'common.criticality.medium',
      [Severity.High]: 'common.criticality.high',
      [Severity.Critical]: 'common.criticality.critical',
      [Severity.Unknown]: 'common.criticality.unknown',
    };

    return severity != undefined ? severities[severity] : '';
  }
}
